module.exports = __webpack_public_path__ + "img/personal_data__flatline.d80a3138.svg";